import { AdminShell } from "@project/admin/components/admin-shell";
import {
  ResourceTable,
  type Field,
} from "@project/admin/components/resource-table";

const fields: Field[] = [
  {
    name: "title",
    label: "Seva Title",
    required: true,
    showInTable: true,
    placeholder: "One Day Meal Seva",
  },
  {
    name: "category_id",
    label: "Category",
    lookup: { table: "donation_categories", labelField: "name" },
  },
  { name: "description", label: "Description", type: "textarea" },
  { name: "image_url", label: "Image URL", type: "url" },
  {
    name: "amount_type",
    label: "Amount Type",
    type: "select",
    showInTable: true,
    options: ["fixed", "custom", "range"].map(v => ({ value: v, label: v })),
  },
  {
    name: "fixed_amount",
    label: "Fixed Amount (₹)",
    type: "number",
    showInTable: true,
    help: "Used when type is fixed.",
  },
  { name: "min_amount", label: "Minimum (₹)", type: "number" },
  { name: "suggested_amounts", label: "Suggested Amounts (₹)", type: "tags" },
  {
    name: "date_required",
    label: "Date Selection Required?",
    type: "boolean",
    help: "e.g. Birthday seva — donor picks a date.",
  },
  { name: "occasion_required", label: "Occasion Required?", type: "boolean" },
  {
    name: "in_memory_option",
    label: "In Memory / Honour Of?",
    type: "boolean",
  },
  { name: "is_active", label: "Active", type: "boolean", showInTable: true },
  { name: "display_order", label: "Display Order", type: "number" },
];

export default function Page() {
  return (
    <AdminShell
      title="Seva / Sponsorship Options"
      subtitle="One-day meal, tiffin, birthday seva, anniversary, festival seva — Indian trust style"
    >
      <ResourceTable
        table="seva_options"
        title="Seva Option"
        fields={fields}
        searchFields={["title"]}
        orderBy="display_order"
        orderAsc
      />
    </AdminShell>
  );
}
